/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const walletTopUpDataSchema = z.object({
	returnUrl: z.string().url().nullable().optional(),
	profileId: z.string().uuid().nullable().optional(),
})

export type WalletTopUpDataSchema = z.infer<typeof walletTopUpDataSchema>
